import type { AttackKind } from './simulation'

export type ImpactCameraSample={
  x:number;y:number;z:number;attackKind:AttackKind|null;precision:number
}
const clamp01=(value:number)=>Math.max(0,Math.min(1,Number.isFinite(value)?value:0))

export function resolveImpactCameraFocus(
  centerX:number,
  centerZ:number,
  baseY:number,
  cue:ImpactCameraSample|undefined,
  remaining:number,
){
  if(!cue||remaining<=0)return{x:centerX,y:baseY,z:centerZ,blend:0}
  const pulse=clamp01(remaining*8)
  const attackFocus=cue.attackKind==='special'?.84:cue.attackKind==='heavy'?.72:cue.attackKind==='throw'?.68:.58
  const precision=clamp01(cue.precision)
  const blend=clamp01(pulse*attackFocus*(.72+precision*.28))
  return{
    x:centerX+(cue.x-centerX)*blend,
    y:baseY+(cue.y-baseY)*blend,
    z:centerZ+(cue.z-centerZ)*blend,
    blend,
  }
}
